module.exports = __webpack_public_path__ + "img/big-number-photos.5ed26212.svg";